import { SxProps, Theme } from '@mui/material';

export const stacksMain: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem',
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  position: 'relative',
};

export const stacksWrapper: SxProps<Theme> = {
  flex: 1,
};
